/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable eqeqeq */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import ApiUtils from 'api/ApiUtils';
import React, {useEffect, useState} from 'react';
import {
  type ClubFormProps,
  type CategoryStatusList,
  type CategoryDetailsTypes,
} from 'utils/TypeConfig';
import categoryImagePlaceholder from 'assets/images/default-placeholder.jpg';

import {variables} from 'utils/constant';
import {Button, Col, Form, Row, Table} from 'react-bootstrap';

import {type FormikErrors, useFormik} from 'formik';
import * as Yup from 'yup';
import {toast} from 'react-toastify';
import {renderCategoryOptions} from 'helpers/CategoryOption';
import 'react-time-picker/dist/TimePicker.css';
import Flatpickr from 'react-flatpickr';
import 'flatpickr/dist/themes/material_green.css'; // Import Flatpickr styling
import FileUploader from 'Common/FileUploader';
import {setCountryCode} from 'slices/common/reducer';
import {useDispatch, useSelector} from 'react-redux';
import phone from 'phone';
import {type AppDispatch} from 'store';
interface Club {
  id: number;
  name: string;
}
interface ClubRow {
  id: number;
  name: string;
  type: string;
  commision_status: string;
  cuisine: string;
  tag: string;
  indoors: string;
  outdoors: string;
  bar: string;
  special_events: string;
  opening_time: string;
  service_time: string;
  min_party_size: string;
  max_party_size: string;
  price_range: string;
  description: string;
  image: any;
  files: any;
  venue_id: string;
  address: string;
  service_type: any;
  weekday_discount: string;
  weekend_discount: string;
  status: string;
  table_booking_recipient_country_id: number | null;
  table_booking_recipient: number | null;
}
interface ClubFormValues {
  clubs: ClubRow[]; // ✅ Ensure "clubs" exists in the type
}
interface UploadedFile {
  image: File;
  preview: string;
  type: 'image' | 'video';
}
interface UploadedFileNew {
  image: File;
  preview: string;
  type: 'image' | 'video' | 'delete';
  image_name: string;
}

const RestaurantForm: React.FC<ClubFormProps> = ({
  handleClose,
  setIsEditCategory,
  setIsAddCategory,
  editData,
  clubs,
}) => {
  const dispatch = useDispatch<AppDispatch>();
  const [status] = useState([
    {
      id: variables.RESTAURANT_ACTIVE_STATUS_ID,
      name: variables.RESTAURANT_ACTIVE_STATUS,
    },
    {
      id: variables.RESTAURANT_INACTIVE_STATUS_ID,
      name: variables.RESTAURANT_INACTIVE_STATUS,
    },
  ]);

  const [statusType] = useState([
    {id: variables.EVENT_ACTIVE_STATUS_ID, name: variables.EVENT_ACTIVE_STATUS},
    {
      id: variables.EVENT_INACTIVE_STATUS_ID,
      name: variables.EVENT_INACTIVE_STATUS,
    },
  ]);

  const clubType = [
    {
      id: 1,
      name: 'Beach/Restaurant',
    },
    {
      id: 2,
      name: 'Fine-Dining',
    },
    {
      id: 3,
      name: 'NightClub/Restaurant',
    },
    // {
    //   id: 4,
    //   name: 'Trendy',
    // },
  ];

  const [categoryList, setCategoryList] = useState([]);
  useEffect(() => {
    const fetchCategoryList = async (): Promise<void> => {
      try {
        const response: any = await ApiUtils.getVenueList('?type=restaurant');
        console.log('🚀 ~ fetchCategoryList ~ response:', response);
        setCategoryList(response);
      } catch (err) {
        console.error(err);
      }
    };

    void fetchCategoryList();
  }, []);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [VenueTypeOption, setVenueTypeOption] = useState<any>([]);
  useEffect(() => {
    // fetch venue type
    const fetchVenueTypeList = async (): Promise<void> => {
      try {
        const response: any = await ApiUtils.TypeVenue(); // Ensure parentheses
        const mapData = response?.data?.map((option: any) => {
          return {
            id: option.id,
            name: option.name,
          };
        });

        setVenueTypeOption(mapData || []); // Update state with fetched data
      } catch (error) {
        console.error('Error fetching dress code list:', error);
      }
    };
    void fetchVenueTypeList();
  }, []);

  const [imageDisplay, setImageDisplay] = useState<any>(editData?.logo || '');

  const handleImage = async (
    e: React.ChangeEvent<HTMLInputElement>,
    index: number,
    venuewImage: boolean = false,
  ): Promise<void> => {
    if (venuewImage) {
      editData?.id
        ? await formikEdit.setFieldValue('image', e)
        : await formik.setFieldValue(`clubs.${index}.image`, e);
      setisImageChange(true);
    } else {
      const file = e.target.files?.[0];

      if (file !== null && file) {
        const validImageTypes = [
          'image/jpeg',
          'image/png',
          'image/jpg',
          'image/webp',
        ];

        if (!validImageTypes.includes(file?.type)) {
          // console.error(
          //   'Invalid file type. Please upload an image of type: jpeg, png, jpg, gif, svg, webp. 111111',
          // );
          alert(
            'Invalid file type. Please upload an image of type: jpeg, png, jpg,webp',
          );
          return; // Exit the function if the file type is not valid
        }

        const objectUrl: string = URL.createObjectURL(file);
        editData?.id
          ? setImageDisplay(objectUrl)
          : setImageDisplay((prevState: any) => ({
              ...prevState,
              [index]: objectUrl,
            }));

        editData?.id
          ? await formikEdit.setFieldValue('image', file)
          : await formik.setFieldValue(`clubs.${index}.image`, file);
        setisImageChange(true);
      }
    }
  };

  const [uploadedFiles, setUploadedFiles] = useState<any[]>([]);
  const handleFilesAdded = async (
    files: UploadedFile[],
    index: number,
  ): Promise<void> => {
    // console.log('🚀 ~ handleFilesAdded ~ files:', [...files], 'Index:', index);

    setUploadedFiles((prevState: any) => {
      return {
        ...prevState,
        [index]: files, // ✅ Store files directly for the correct row index
      };
    });

    // Process images for cropping
    files.forEach(async (file: any) => {
      await replaceImageWithCropped(file);
    });

    // Ensure Formik updates the correct field
    const hasDeleteType = files.every((file: any) => file.type === 'delete');
    if (files.length === 0 || hasDeleteType) {
      // validation.setFieldValue(`clubs.${index}.image`, []);
      editData?.id
        ? await formikEdit.setFieldValue('files', [])
        : await formik.setFieldValue(`clubs.${index}.files`, []);
    } else {
      // validation.setFieldValue(`clubs.${index}.image`, [...files]);
      editData?.id
        ? await formikEdit.setFieldValue('files', [...files])
        : await formik.setFieldValue(`clubs.${index}.files`, [...files]);
    }
  };

  const replaceImageWithCropped = async (data: {
    fileName: string;
    croppedPreview: RequestInfo | URL;
    image: File;
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  }) => {
    if (data.croppedPreview) {
      try {
        // Fetch the croppedPreview blob
        const response = await fetch(data.croppedPreview);
        const blob = await response.blob();

        // Create a new File object from the blob
        const croppedImageFile = new File([blob], data?.fileName, {
          type: blob.type,
        });

        // Replace the image with the cropped file
        data.image = croppedImageFile;
      } catch (error) {
        console.error('Error replacing image with cropped preview:', error);
      }
    } else {
      console.warn('No croppedPreview available to replace the image.');
    }
  };

  const initialRow: ClubRow = {
    id: 1, // Default ID
    name: '',
    type: '',
    commision_status: '',
    cuisine: '',
    tag: '',
    indoors: '',
    outdoors: '',
    bar: '',
    special_events: '',
    opening_time: '',
    service_time: '',
    min_party_size: '',
    max_party_size: '',
    price_range: '',
    description: '',
    image: '',
    files: '',
    venue_id: '',
    address: '',
    service_type: '',
    weekday_discount: '',
    weekend_discount: '',
    status: '',
    table_booking_recipient_country_id: null,
    table_booking_recipient: null,
  };

  const [rows, setRows] = useState([{...initialRow}]);
  const [isImageChange, setisImageChange] = useState(false);

  const [submittedRows, setSubmittedRows] = useState<any[]>([]);

  const validationSchema = Yup.object({
    clubs: Yup.array().of(
      Yup.object().shape({
        id: Yup.number().required(),
        // name: Yup.string().required('Name is required'),
        name: Yup.string()
          .required('Name is required')
          .test(
            'unique-name',
            'Restaurant name already available',
            function (value) {
              // 🔥 Keep the "already available" error if it's set
              return !this.parent.nameTaken;
            },
          ),
        type: Yup.string().required('Type is required'),
        commision_status: Yup.string().required('Commision status is required'),
        // cuisine: Yup.string().required('Cuisine is required'),
        indoors: Yup.string().required('Indoors status is required'),
        outdoors: Yup.string().required('Outdoors status is required'),
        bar: Yup.string().required('Bar status is required'),
        special_events: Yup.string().required('Special event is required'),

        price_range: Yup.string()
          .matches(/^\d+(\.\d{1,2})?$/, 'Price range must be at least 1')
          .test(
            'is-positive',
            'Price range must be greater than 0',
            (value: any) => parseFloat(value) > 0,
          )
          .required('Price range is required'),

        description: Yup.string().required('Description is required'),
        image: Yup.mixed().required('Logo is required'),
        venue_id: Yup.string().required('Venue is required'),
        // files: Yup.array()
        //   .of(Yup.mixed().required('File is required'))
        //   .test(
        //     'is-required',
        //     'At least one file is required.',
        //     function (value) {
        //       return Array.isArray(value) && value.length > 0; // Ensures validation is checked on submit
        //     },
        //   ),
        // .max(4, 'You can upload a maximum of 4 files.'),
        address: Yup.string().required('Adress is required'),
        min_party_size: Yup.number()
          .typeError('Min party size must be a number')
          .required('Min party size is required')
          .min(2, 'Min party size must be at least 2'),
        max_party_size: Yup.number()
          .typeError('Max party size must be a number')
          .required('Max party size is required')
          .min(2, 'Max party size must be at least 2')
          .test(
            'is-greater',
            'Max party size must be greater than Min party size',
            function (value) {
              return value > this.parent.min_party_size; // Must be strictly greater
            },
          ),

        service_type: Yup.array()
          .of(
            Yup.object().shape({
              name: Yup.string().required('Service type is required'),
              opening_time: Yup.string().when('name', (name, schema) =>
                name ? schema.required('Opening time is required') : schema,
              ),
              closing_time: Yup.string().when('name', (name, schema) =>
                name ? schema.required('Closing time is required') : schema,
              ),
            }),
          )
          .test(
            'is-required',
            'At least one Service type is required.',
            function (value) {
              return Array.isArray(value) && value.length > 0;
            },
          ),

        weekday_discount: Yup.number()
          .nullable()
          .typeError('Weekday discount must be a number')
          .min(1, 'Weekday discount must be at least 1'),
        weekend_discount: Yup.number()
          .nullable()
          .typeError('Weekend discount must be a number')
          .min(1, 'Weekend discount must be at least 1'),

        status: Yup.string().required('Status is required'),
        table_booking_recipient: Yup.number()
          .typeError('Phone number is required')
          .required('Phone number is required')
          .test(
            'custom-phone-validation-add',
            'Phone number is invalid.',
            function (value) {
              // eslint-disable-next-line @typescript-eslint/naming-convention
              const {
                // eslint-disable-next-line @typescript-eslint/naming-convention
                selected_country_code,
                // eslint-disable-next-line @typescript-eslint/naming-convention
                table_booking_recipient_country_id,
                // eslint-disable-next-line @typescript-eslint/naming-convention
                table_booking_recipient,
                // eslint-disable-next-line @typescript-eslint/naming-convention
                country_code,
              }: any = this.parent;

              if (!value) return false; // Ensure value exists

              const country = countryCode.filter(
                (country: any) =>
                  country?.id == table_booking_recipient_country_id,
              );

              return customFunction(
                table_booking_recipient,
                country_code ?? 971,
              );
            },
          ),
      }),
    ),
  });

  const formik = useFormik<ClubFormValues>({
    initialValues: {
      clubs: rows.map(row => ({
        id: row.id,
        name: '',
        type: '',
        commision_status: '',
        cuisine: '',
        tag: '',
        indoors: '',
        outdoors: '',
        bar: '',
        special_events: '',
        opening_time: '',
        service_time: '',
        min_party_size: '',
        max_party_size: '',
        price_range: '',
        description: '',
        image: '',
        files: [],
        venue_id: '',
        address: '',
        service_type: [],
        weekday_discount: '',
        weekend_discount: '',
        status: '',
        table_booking_recipient_country_id: null,
        table_booking_recipient: null,
      })),
    },
    validationSchema,
    onSubmit: async values => {
      console.log('Submitting all rows:', values.clubs);

      try {
        const responses = await Promise.all(
          values.clubs.map(async club => {
            const formData = new FormData();
            formData.append('restaurant_id', club.id.toString());
            formData.append('name', club?.name || '');
            formData.append('type', club?.type || '');
            formData.append('indoors', club?.indoors || '');
            formData.append('outdoors', club.outdoors || '');
            formData.append('bar', club.bar || '');
            formData.append('special_event', club.special_events || '');
            formData.append('service_time', club.service_time || '');
            formData.append('open_time', club.opening_time || '');
            formData.append('min_party_size', club.min_party_size || '');
            formData.append('max_party_size', club.max_party_size || '');
            formData.append('price_range', club.price_range || '');
            formData.append('description', club.description || '');
            formData.append('cuisine', club.cuisine || '');
            formData.append('tag', club.tag || '');
            formData.append('commission', club.commision_status || '');
            formData.append('venue_id', club.venue_id || '');
            formData.append('address', club.address || '');
            formData.append('weekday_discount', club.weekday_discount || '');
            formData.append('weekend_discount', club.weekend_discount || '');
            formData.append(
              'table_booking_recipient',
              String(club.table_booking_recipient ?? ''),
            );

            formData.append(
              'table_booking_recipient_country_id',
              String(club.table_booking_recipient_country_id ?? ''),
            );
            formData.append('status', club.status || '');

            // Append logo only if it's a File object
            if (club.image instanceof File) {
              formData.append('logo', club.image);
            } else {
              // console.log('Logo is not a file, skipping upload');
              formData.append('logo', club.image);
            }

            if (club?.files && typeof club.files !== 'string') {
              club.files.forEach((file: any, index: number) => {
                if (file.id) {
                  // ✅ Append existing file metadata (convert values to string)
                  const {id, ...rest} = file; // Exclude `id`
                  Object.entries(rest).forEach(([key, value]) => {
                    formData.append(`file[${index}][${key}]`, String(value)); // 🔥 Convert value to string
                  });
                } else {
                  // ✅ Append new file with binary data
                  const {type, preview, image, ...rest} = file; // Exclude `type` and `preview`
                  formData.append(`file[${index}][image]`, image as Blob); // 🔥 Ensure image is a Blob

                  Object.entries(rest).forEach(([key, value]) => {
                    formData.append(`file[${index}][${key}]`, String(value)); // 🔥 Convert value to string
                  });
                }
              });
            }

            club?.service_type.forEach(
              (
                service: {
                  name: string | Blob;
                  opening_time: string | Blob;
                  closing_time: string | Blob;
                },
                index: any,
              ) => {
                formData.append(`service_type[${index}][name]`, service.name);
                formData.append(
                  `service_type[${index}][opening_time]`,
                  service.opening_time,
                );
                formData.append(
                  `service_type[${index}][closing_time]`,
                  service.closing_time,
                );
              },
            );

            return await ApiUtils.addRestaurantProfile(formData);
          }),
        );

        responses.forEach((response: any) => toast.success(response.message));

        if (setIsAddCategory) {
          setIsAddCategory((prev: boolean) => !prev);
        }
        handleClose();
      } catch (error: any) {
        toast.error(error?.response?.data?.message || 'Submission failed');
      }
    },
  });

  const addRow = async (): Promise<void> => {
    const newRow: ClubRow = {...initialRow, id: rows.length + 1};
    setRows([...rows, newRow]);

    await formik.setValues({
      clubs: [...formik.values.clubs, newRow],
    });
  };

  const removeRow = async (index: number): Promise<void> => {
    if (rows.length > 1) {
      // Remove row from the `rows` state
      const updatedRows = rows.filter((_, i) => i !== index);
      setRows(updatedRows);

      // Remove the corresponding row from Formik values
      const updatedClubs = formik.values.clubs.filter((_, i) => i !== index);

      // Ensure Formik updates properly
      await formik.setValues({...formik.values, clubs: updatedClubs});

      // Remove errors and touched state correctly
      const updatedErrors: Array<FormikErrors<ClubRow>> = Array.isArray(
        formik.errors.clubs,
      )
        ? formik.errors.clubs.filter(
            (error): error is FormikErrors<ClubRow> =>
              typeof error !== 'string',
          )
        : [];

      const updatedTouched =
        Array.isArray(formik.touched.clubs) && formik.touched.clubs.length
          ? formik.touched.clubs.filter((_, i) => i !== index)
          : [];

      // Update errors and touched
      formik.setErrors({...formik.errors, clubs: updatedErrors});
      await formik.setTouched({...formik.touched, clubs: updatedTouched});

      // **🔹 Remove the image for the deleted row**

      setImageDisplay((prevState: any) => {
        const updatedImages: Record<number, string> = {};

        Object.keys(prevState).forEach((key, i) => {
          const oldIndex = Number(key);
          if (oldIndex !== index) {
            const newIndex = oldIndex > index ? oldIndex - 1 : oldIndex;
            updatedImages[newIndex] = prevState[oldIndex]; // Shift images
          }
        });

        return updatedImages;
      });

      // Ensure UI updates correctly
      await formik.validateForm();
    }
  };

  // const formikEdit = editData?.id ? formikArray?.[editData?.id] ?? null : null;
  // 🔹 Create a separate formik instance for editData

  const validationSchemaEdit = Yup.object().shape({
    name: Yup.string()
      .required('Name is required')
      .test(
        'unique-name',
        'Restaurant name already available',
        function (value) {
          // 🔥 Keep the "already available" error if it's set
          return !this.parent.nameTaken;
        },
      ),
    type: Yup.string().required('Type is required'),
    commision_status: Yup.string().required('Commision status is required'),
    // cuisine: Yup.string().required('Cuisine is required'),
    indoors: Yup.string().required('Indoors status is required'),
    outdoors: Yup.string().required('Outdoors status is required'),
    bar: Yup.string().required('Bar status is required'),
    special_events: Yup.string().required('Special event is required'),
    venue_id: Yup.string().required('Venue is required'),
    price_range: Yup.string()
      .matches(/^\d+(\.\d{1,2})?$/, 'Price range must be at least 1')
      .test(
        'is-positive',
        'Price range must be greater than 0',
        (value: any) => parseFloat(value) > 0,
      )
      .required('Price range is required'),
    description: Yup.string().required('Description is required'),
    image: Yup.mixed().required('Logo is required'),

    files: Yup.array()
      .of(Yup.mixed().required('File is required'))
      .test('is-required', 'At least one file is required.', function (value) {
        return Array.isArray(value) && value.length > 0; // Ensures validation is checked on submit
      }),
    address: Yup.string().required('Adress is required'),
    min_party_size: Yup.number()
      .typeError('Min party size must be a number')
      .required('Min party size is required')
      .min(2, 'Min party size must be at least 2'),
    max_party_size: Yup.number()
      .typeError('Max party size must be a number')
      .required('Max party size is required')
      .min(2, 'Max party size must be at least 2')
      .test(
        'is-greater',
        'Max party size must be greater than Min party size',
        function (value) {
          return value > this.parent.min_party_size; // Must be strictly greater
        },
      ),
    service_type: Yup.array()
      .of(
        Yup.object().shape({
          name: Yup.string().required('Service type is required'),
          opening_time: Yup.string().when('name', (name, schema) =>
            name ? schema.required('Opening time is required') : schema,
          ),
          closing_time: Yup.string().when('name', (name, schema) =>
            name ? schema.required('Closing time is required') : schema,
          ),
        }),
      )
      .test(
        'is-required',
        'At least one Service type is required.',
        function (value) {
          return Array.isArray(value) && value.length > 0;
        },
      ),

    weekday_discount: Yup.number()
      .nullable()
      .typeError('Weekday discount must be a number')
      .min(1, 'Weekday discount must be at least 1'),
    weekend_discount: Yup.number()
      .nullable()
      .typeError('Weekend discount must be a number')
      .min(1, 'Weekend discount must be at least 1'),
    status: Yup.string().required('Status is required'),
    table_booking_recipient: Yup.number()
      .required('Phone number is required')
      .nullable()
      .test(
        'custom-phone-validation',
        'Phone number is invalid.',
        function (value) {
          console.log('this.parent', this.parent);
          // eslint-disable-next-line @typescript-eslint/naming-convention
          const {
            // eslint-disable-next-line @typescript-eslint/naming-convention
            selected_country_code,
            // eslint-disable-next-line @typescript-eslint/naming-convention
            table_booking_recipient_country_id,
            // eslint-disable-next-line @typescript-eslint/naming-convention
            table_booking_recipient,
            // eslint-disable-next-line @typescript-eslint/naming-convention
            country_code,
          }: any = this.parent;

          if (!value) return false; // Ensure value exists

          const country = countryCode.filter(
            (country: any) => country?.id == table_booking_recipient_country_id,
          );

          console.log(
            'selected_country_code xxx',
            'country code:',
            selected_country_code,
            country?.country_code,
            'number:',
            table_booking_recipient,
            'country_id:',
            table_booking_recipient_country_id,
            country_code,
          );

          return customFunction(
            table_booking_recipient,
            selected_country_code ?? country?.country_code,
          );
        },
      ),
    // table_booking_recipient: Yup.lazy((value, {parent}) => {
    //   return Yup.string()
    //     .nullable()
    //     .test(
    //       'custom-phone-validation',
    //       'Phone number is invalid.',
    //       function (value) {
    //         // eslint-disable-next-line @typescript-eslint/naming-convention
    //         const {country_code} = this.parent;
    //         if (!value) return false; // Only allow empty if not required
    //         return customFunction(value, country_code ?? 971);
    //       },
    //     )
    //     .required('Phone number is required');
    // }),
  });
  const formikEdit = useFormik({
    initialValues: {
      name: editData?.restaurant_name ?? '',
      venue_id: editData?.venue_id ?? '',
      type: editData?.type ?? '',
      commision_status: editData?.commission ?? '',
      cuisine: editData?.cuisine ?? '',
      tag: editData?.tag ?? '',
      indoors: editData?.indoors ?? '',
      outdoors: editData?.outdoors ?? '',
      bar: editData?.bar ?? '',
      special_events: editData?.special_event ?? '',
      opening_time: editData?.open_time ?? '',
      service_time: editData?.service_time ?? '',
      min_party_size: editData?.min_party_size ?? '',
      max_party_size: editData?.max_party_size ?? '',
      price_range: editData?.price_range ?? '',
      description: editData?.description ?? '',
      image: editData?.logo ?? null,
      files:
        editData?.restaurant_profile_images?.length > 0
          ? editData?.restaurant_profile_images
          : [],
      address: editData?.address ?? '',
      table_booking_recipient_country_id:
        editData?.table_booking_recipient_country_id !== ''
          ? editData?.table_booking_recipient_country_id
          : null,
      table_booking_recipient:
        editData?.table_booking_recipient !== ''
          ? editData?.table_booking_recipient
          : null,
      country_code: editData?.table_booking_recipient_country_id || '', // Default ID for +971
      status: editData?.status ?? '',
      weekday_discount: editData?.weekday_discount ?? '',
      weekend_discount: editData?.weekend_discount ?? '',
      // service_type: editData?.restaurant_service_type ?? [],
      service_type:
        editData?.restaurant_service_type?.map((service: any) => ({
          name: service.service_type, // Ensure the key matches how you're using it in the component
          opening_time: service.opening_time || '',
          closing_time: service.closing_time || '',
        })) ?? [],
    },
    enableReinitialize: true, // Ensures form updates when editData changes
    validationSchema: validationSchemaEdit,
    onSubmit: async values => {
      console.log('Submitting editData:', {id: editData?.id, ...values});

      try {
        const formData = {
          id: editData?.id,
          name: values?.name,
          restaurant_id: editData?.club_id,
          type: values?.type,
          indoors: values?.indoors,
          outdoors: values?.outdoors,
          bar: values?.bar,
          special_event: values?.special_events,
          service_time: values?.service_time,
          open_time: values?.opening_time,
          min_party_size: values?.min_party_size,
          max_party_size: values?.max_party_size,

          price_range: values?.price_range,
          description: values?.description,
          cuisine: values?.cuisine,
          tag: values?.tag,
          commission: values?.commision_status,
          logo:
            typeof values?.image !== 'string'
              ? values?.image
              : isImageChange
                ? values?.image
                : {},
          file:
            values?.files && typeof values.files !== 'string'
              ? values.files.map((file: any) => {
                  // If the file has an "id" key, remove "type" only
                  if (file.id) {
                    const {...rest} = file; // Destructure and exclude type
                    return rest; // Return the remaining properties without "type"
                  } else {
                    // If the file doesn't have an "id" key, remove both "type" and "preview"
                    const {type, preview, ...rest} = file; // Destructure and exclude type and preview
                    return rest; // Return the remaining properties without "type" and "preview"
                  }
                })
              : '',
          venue_id: values?.venue_id ?? '',

          address: values?.address ?? '',
          status: values?.status ?? '',
          table_booking_recipient_country_id: Number(
            values?.table_booking_recipient_country_id,
          ),
          table_booking_recipient:
            values?.table_booking_recipient !== undefined || null
              ? values?.table_booking_recipient
              : null,
          weekday_discount: values?.weekday_discount ?? '',
          weekend_discount: values?.weekend_discount ?? '',
          service_type: values?.service_type,
        };

        const response: any = await ApiUtils.addRestaurantProfile(formData);
        toast.success(response?.message);

        if (setIsEditCategory) {
          setIsEditCategory((prev: boolean) => !prev);
        }
        handleClose();
      } catch (error: any) {
        toast.error(error?.response?.data?.message);
      }
    },
  });
  // Ensure form validation triggers
  const handleEditSubmit = async (): Promise<void> => {
    await formikEdit.setTouched({
      type: true,
      name: true,
      commision_status: true,
      cuisine: true,
      tag: true,
      indoors: true,
      outdoors: true,
      bar: true,
      special_events: true,
      // opening_time: true,
      // service_time: true,
      min_party_size: true,
      max_party_size: true,
      price_range: true,
      description: true,
      image: true,
      files: true,
      venue_id: true,
      address: true,
      status: true,
      weekday_discount: true,
      weekend_discount: true,
      service_type: true,
      table_booking_recipient: true,
    });

    await formikEdit.validateForm().then(errors => {
      if (Object.keys(errors).length === 0) {
        formikEdit.handleSubmit();
      }
    });
  };
  // create a one function ehch check restaurant name is avaiable or not call API
  const checkRestaurantNameAvailability = async (
    name: string,
    index: number,
  ): Promise<boolean> => {
    try {
      const formData = {
        name,
        ...(editData?.id && {old_name: editData?.restaurant_name}),
      };
      console.log(formData, 'formData');
      const response: any =
        await ApiUtils.checkRestaurantNameAvailability(formData);

      if (response?.data?.is_exists === true) {
        if (editData?.id) {
          await formikEdit.setFieldTouched(`name`, true);

          // ✅ Set a hidden flag to persist error
          await formikEdit.setFieldValue(`nameTaken`, true, false); // Prevents immediate revalidation

          // ✅ Set field error
          formikEdit.setFieldError(`name`, 'Restaurant name already available');
        } else {
          await formik.setFieldTouched(`clubs[${index}].name`, true);

          // ✅ Set a hidden flag to persist error
          await formik.setFieldValue(`clubs[${index}].nameTaken`, true, false); // Prevents immediate revalidation

          // ✅ Set field error
          formik.setFieldError(
            `clubs[${index}].name`,
            'Restaurant name already available',
          );
        }

        return false;
      } else {
        // ✅ Remove error if name is available
        await formik.setFieldValue(`clubs[${index}].nameTaken`, false, false);
        formik.setFieldError(`clubs[${index}].name`, undefined);

        await formikEdit.setFieldValue(`nameTaken`, false, false);
        formikEdit.setFieldError(`name`, undefined);
        return true;
      }
    } catch (error: any) {
      toast.error(error?.response?.data?.message);
      return false;
    }
  };

  const countryCode = useSelector(
    (state: any) => state.commonState.countryCode,
  );

  useEffect(() => {
    const fetchCountryCode = async (): Promise<void> => {
      try {
        const response: any = await ApiUtils.getCountryCode();
        dispatch(setCountryCode(response?.data)); // Updates Redux store
      } catch (err) {
        console.error(err);
      }
    };

    if (!countryCode || countryCode.length === 0) {
      void fetchCountryCode();
    }
  }, [countryCode, dispatch]); // Re-run only if countryCode changes

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  // function customFunction(phoneNumber: string, code: string) {
  //   console.log('🚀 ~ customFunction ~ phoneNumber:', phoneNumber, code);
  //   const status = phone(`+${code} ${phoneNumber}`);
  //   return status?.isValid;
  // }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  function customFunction(phoneNumber: string, code: number) {
    // const cleanedPhone = phoneNumber?.replace(/\s+/g, '');
    const cleanedPhone = String(phoneNumber).replace(/\s+/g, '');

    // UAE landline area codes
    const landlineAreaCodes = ['2', '3', '4', '6', '7', '9'];

    // Check if UAE landline
    if (Number(code) === 971) {
      const areaCode = cleanedPhone.charAt(0);

      const isLandline =
        landlineAreaCodes.includes(areaCode) && /^\d{8}$/.test(cleanedPhone);

      if (isLandline) {
        console.log('📞 Validating as UAE landline:', isLandline);
        return true;
      }
    }

    // Use phone library for mobile or other countries
    const status = phone(`+${code} ${phoneNumber}`);
    console.log('📱 Validating with phone lib:', status);
    return status?.isValid;
  }

  console.log('Validation error', formikEdit.errors, formik?.errors?.clubs);

  return (
    <div>
      {/* <Container fluid className="p-3"> */}
      <Row>
        <Col>
          <div className="table-responsive">
            <Table striped bordered hover className="text-center">
              <thead className="bg-light">
                <tr>
                  <th>Venue</th>
                  <th> Logo </th>
                  <th>Restaurant Name</th>
                  <th>Restaurant Images</th>
                  <th>Type</th>
                  <th>Address</th>
                  <th>Do they pay Commission? </th>
                  <th>Cuisine</th>
                  <th>Tag</th>
                  <th>Indoors</th>
                  <th>Outdoors</th>
                  <th>Bar</th>
                  <th>Special events</th>
                  <th>Service Type</th>
                  {/* <th>Opening time</th> */}
                  <th>Min party size</th>
                  <th>Max party size</th>
                  <th>Price range/person</th>
                  <th>Weekday Discount %</th>
                  <th>Weekend Discount %</th>
                  <th>Description/Caption</th>
                  <th>Table booking recipient</th>
                  <th>Status</th>
                  {!editData?.id ? <th></th> : null}
                </tr>
              </thead>
              <tbody>
                {/* {clubs.map((club, index) => ( */}
                {editData?.id ? (
                  <>
                    <tr key={editData?.id}>
                      <td>
                        <div className="mb-3 club-select">
                          <Form.Select
                            className="form-select"
                            name="venue_id"
                            id={`venue_id${editData?.id}`}
                            value={formikEdit?.values?.venue_id ?? ''}
                            onChange={async e => {
                              // eslint-disable-next-line @typescript-eslint/no-confusing-void-expression
                              const selectedVenue: any = categoryList.find(
                                // eslint-disable-next-line array-callback-return
                                (venue: CategoryDetailsTypes) =>
                                  // eslint-disable-next-line @typescript-eslint/no-unused-expressions
                                  String(venue.id) == e.target.value,
                              );

                              await formikEdit.setFieldValue(
                                `address`,
                                selectedVenue?.address || '',
                              );
                              await handleImage(
                                selectedVenue?.image,
                                editData?.id,
                                true,
                              );

                              setImageDisplay(selectedVenue?.image);
                              setTimeout(() => {
                                void formikEdit.setFieldValue(
                                  `venue_id`,
                                  selectedVenue?.id || '',
                                );
                              }, 0);

                              // eslint-disable-next-line @typescript-eslint/no-unused-expressions
                              formikEdit?.handleChange(e);
                            }}
                            onBlur={formikEdit?.handleBlur}>
                            <option disabled value="">
                              --Select Venue--
                            </option>
                            {categoryList?.map(
                              (data: CategoryDetailsTypes, i) => {
                                // Ensure the category name does not match the editEvent's name
                                if (editData?.event_name !== data.name) {
                                  const categoryName = renderCategoryOptions(
                                    data,
                                    categoryList,
                                    [],
                                    editData?.event_name,
                                  );

                                  return (
                                    <option value={data.id} key={i}>
                                      {categoryName}
                                    </option>
                                  );
                                }
                                return null; // Avoid rendering anything if the condition is not met
                              },
                            )}
                          </Form.Select>
                          {formikEdit.touched?.venue_id &&
                            formikEdit.errors?.venue_id && (
                              <p className="text-danger">
                                {formikEdit.errors?.venue_id as string}
                              </p>
                            )}
                        </div>
                      </td>

                      <td>
                        <div className="club-select">
                          <div className="avatar-upload">
                            <div className="avatar-edit">
                              <input
                                type="file"
                                // id="imageUpload"
                                id={`imageUpload`}
                                name={`image`}
                                onChange={async e => {
                                  await handleImage(e, editData?.id);
                                }}
                                accept="image/jpeg, image/png, image/jpg, image/gif, image/svg+xml, image/webp"
                              />
                              <label
                                htmlFor={`imageUpload`}
                                className="image-upload-cam d-flex justify-content-center align-items-center">
                                <i className="ri-image-fill"></i>
                              </label>
                            </div>
                            <div className="avatar-preview">
                              <img
                                className="preview-select-img img-responsive img-circle"
                                id="imagePreview"
                                alt="User profile picture"
                                src={imageDisplay ?? categoryImagePlaceholder}
                                style={{height: '110px'}}
                              />
                            </div>
                          </div>
                          {formikEdit?.touched.image &&
                            formikEdit?.errors.image && (
                              <p className="text-danger">
                                {formikEdit?.errors.image as string}
                              </p>
                            )}
                        </div>
                      </td>

                      <td>
                        <div className="club-select">
                          <div className="club-select">
                            <Form.Control
                              type="text"
                              name="name"
                              id={`name${editData?.id}`}
                              value={formikEdit?.values.name}
                              onChange={formikEdit?.handleChange}
                              // onBlur={formikEdit?.handleBlur}
                              onBlur={async e => {
                                const isAvailable =
                                  await checkRestaurantNameAvailability(
                                    formikEdit?.values.name,
                                    editData?.id,
                                  );
                                formikEdit?.handleBlur(e);
                              }}
                              isInvalid={
                                !!(
                                  formikEdit?.touched.name &&
                                  formikEdit?.errors.name
                                )
                              }
                            />
                            {formikEdit?.touched.name &&
                              formikEdit?.errors.name && (
                                <p className="text-danger">
                                  {formikEdit?.errors.name as string}
                                </p>
                              )}
                          </div>
                        </div>
                      </td>

                      <td>
                        {/* <FileUploaderClub
                          //  onFilesAdded={handleFilesAdded}
                          onFilesAdded={async files => {
                            await handleFilesAdded(files, 1);
                          }} // Pass rowIndex
                          accept={{
                            'image/*': ['.png', '.jpeg', '.jpg', '.gif'],
                            'video/*': ['.mp4', '.mov', '.avi'],
                          }}
                          multiple={true}
                          images={editData?.restaurant_profile_images} // Display only row-specific images
                          rowIndex={1}
                        /> */}

                        <FileUploader
                          onFilesAdded={async files => {
                            await handleFilesAdded(files, 1);
                          }}
                          accept={{
                            'image/*': ['.png', '.jpeg', '.jpg', '.gif'],
                            'video/*': ['.mp4', '.mov', '.avi'],
                          }}
                          multiple={true}
                          images={editData?.restaurant_profile_images}
                        />
                        {formikEdit.touched?.files &&
                          formikEdit.errors?.files && (
                            <p className="text-danger">
                              {formikEdit?.errors?.files as string}
                            </p>
                          )}
                      </td>

                      <td>
                        <div className="mb-3 club-select">
                          <div className="d-flex"></div>
                          <Form.Select
                            className="form-select"
                            id={`type-Field${editData?.id}`}
                            name="type"
                            value={formikEdit?.values?.type ?? ''}
                            onChange={formikEdit?.handleChange}
                            onBlur={formikEdit?.handleBlur} // Ensure field is marked as touched
                          >
                            <option value="" disabled>
                              --Select Type--{' '}
                            </option>
                            {clubType?.map((data: CategoryStatusList, i) => (
                              <option key={i} value={data.id}>
                                {data.name}
                              </option>
                            ))}
                          </Form.Select>
                          {formikEdit?.touched.type &&
                            formikEdit?.errors.type && (
                              <p className="text-danger">
                                {formikEdit?.errors.type as string}
                              </p>
                            )}
                        </div>
                      </td>

                      <td>
                        <div className="club-select">
                          <Form.Control
                            as="textarea"
                            rows={2}
                            name="address"
                            id={`address${editData?.id}`}
                            value={formikEdit?.values?.address ?? ''}
                            onChange={formikEdit?.handleChange}
                            onBlur={formikEdit?.handleBlur}
                            isInvalid={
                              !!(
                                formikEdit?.touched.address &&
                                formikEdit?.errors.address
                              )
                            }
                          />
                          {formikEdit?.touched.address &&
                            formikEdit?.errors.address && (
                              <p className="text-danger">
                                {formikEdit?.errors.address as string}
                              </p>
                            )}
                        </div>
                      </td>

                      <td>
                        <div className="mb-3 club-select">
                          <Form.Select
                            className="form-select"
                            name="commision_status"
                            id={`commision_status${editData?.id}`}
                            value={formikEdit?.values.commision_status}
                            onChange={formikEdit?.handleChange}
                            onBlur={formikEdit?.handleBlur}>
                            <option value="" disabled>
                              Select
                            </option>
                            {status?.map((data: CategoryStatusList, i) => (
                              <option key={i} value={data.id}>
                                {data.name}
                              </option>
                            ))}
                          </Form.Select>
                          {formikEdit?.touched.commision_status &&
                            formikEdit?.errors.commision_status && (
                              <p className="text-danger">
                                {formikEdit?.errors.commision_status as string}
                              </p>
                            )}
                        </div>
                      </td>
                      <td>
                        <div className="mb-3 club-select">
                          <Form.Control
                            type="text"
                            name="cuisine"
                            id={`cuisine${editData?.id}`}
                            value={formikEdit?.values.cuisine}
                            onChange={formikEdit?.handleChange}
                            onBlur={formikEdit?.handleBlur}
                            isInvalid={
                              !!(
                                formikEdit?.touched.cuisine &&
                                formikEdit?.errors.cuisine
                              )
                            }
                          />
                          {formikEdit?.touched.cuisine &&
                            formikEdit?.errors.cuisine && (
                              <p className="text-danger">
                                {formikEdit?.errors.cuisine as string}
                              </p>
                            )}
                        </div>
                      </td>
                      <td>
                        <div className="mb-3 club-select">
                          <Form.Control
                            type="text"
                            name="tag"
                            id={`tag${editData?.id}`}
                            value={formikEdit?.values.tag}
                            onChange={formikEdit?.handleChange}
                            onBlur={formikEdit?.handleBlur}
                            isInvalid={
                              !!(
                                formikEdit?.touched.tag &&
                                formikEdit?.errors.tag
                              )
                            }
                          />
                          {formikEdit?.touched.tag &&
                            formikEdit?.errors.tag && (
                              <p className="text-danger">
                                {formikEdit?.errors.tag as string}
                              </p>
                            )}
                        </div>
                      </td>
                      <td>
                        <div className="club-select">
                          <Form.Select
                            className="form-select "
                            name="indoors"
                            id={`indoors${editData?.id}`}
                            value={formikEdit?.values.indoors}
                            onChange={formikEdit?.handleChange}
                            onBlur={formikEdit?.handleBlur}>
                            <option value="" disabled>
                              --Select Indoors--
                            </option>
                            {status?.map((data: CategoryStatusList, i) => (
                              <option key={i} value={data.id}>
                                {data.name}
                              </option>
                            ))}
                          </Form.Select>
                          {formikEdit?.touched.indoors &&
                            formikEdit?.errors.indoors && (
                              <p className="text-danger">
                                {formikEdit?.errors.indoors as string}
                              </p>
                            )}
                        </div>
                      </td>
                      <td>
                        <div className="club-select">
                          <Form.Select
                            className="form-select "
                            name="outdoors"
                            id={`outdoors${editData?.id}`}
                            value={formikEdit?.values.outdoors}
                            onChange={formikEdit?.handleChange}
                            onBlur={formikEdit?.handleBlur}>
                            <option value="" disabled>
                              --Select Outdoors--
                            </option>
                            {status?.map((data: CategoryStatusList, i) => (
                              <option key={i} value={data.id}>
                                {data.name}
                              </option>
                            ))}
                          </Form.Select>
                          {formikEdit?.touched.outdoors &&
                            formikEdit?.errors.outdoors && (
                              <p className="text-danger">
                                {formikEdit?.errors.outdoors as string}
                              </p>
                            )}
                        </div>
                      </td>
                      <td>
                        <div className="club-select">
                          <Form.Select
                            className="form-select "
                            name="bar"
                            id={`bar${editData?.id}`}
                            value={formikEdit?.values.bar}
                            onChange={formikEdit?.handleChange}
                            onBlur={formikEdit?.handleBlur}>
                            <option value="" disabled>
                              --Select Bar--
                            </option>
                            {status?.map((data: CategoryStatusList, i) => (
                              <option key={i} value={data.id}>
                                {data.name}
                              </option>
                            ))}
                          </Form.Select>
                          {formikEdit?.touched.bar &&
                            formikEdit?.errors.bar && (
                              <p className="text-danger">
                                {formikEdit?.errors.bar as string}
                              </p>
                            )}
                        </div>
                      </td>
                      <td>
                        <div className="club-select">
                          <Form.Select
                            className="form-select "
                            name="special_events"
                            id={`special_events${editData?.id}`}
                            value={formikEdit?.values.special_events}
                            onChange={formikEdit?.handleChange}
                            onBlur={formikEdit?.handleBlur}>
                            <option value="" disabled>
                              Special Events
                            </option>
                            {status?.map((data: CategoryStatusList, i) => (
                              <option key={i} value={data.id}>
                                {data.name}
                              </option>
                            ))}
                          </Form.Select>
                          {formikEdit?.touched.special_events &&
                            formikEdit?.errors.special_events && (
                              <p className="text-danger">
                                {formikEdit?.errors.special_events as string}
                              </p>
                            )}
                        </div>
                      </td>

                      <td>
                        <div className="club-select">
                          {/* Service Type Selection (Brunch, Lunch, Dinner) */}

                          {(() => {
                            const existingServiceTypes =
                              formikEdit.values?.service_type ||
                              editData?.service_type ||
                              [];
                            const order = ['brunch', 'lunch', 'dinner'];

                            const sortedServices = [
                              ...existingServiceTypes,
                            ].sort(
                              (a, b) =>
                                order.indexOf(a.name) - order.indexOf(b.name),
                            );

                            const getPreviousClosingTime = (
                              currentType: any,
                              // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
                            ) => {
                              const prevType =
                                order[order.indexOf(currentType) - 1];
                              return (
                                sortedServices.find(s => s.name === prevType)
                                  ?.closing_time || ''
                              );
                            };

                            return order.map((type, index) => {
                              const isChecked = sortedServices.some(
                                s => s.name === type,
                              );
                              const serviceIndex = sortedServices.findIndex(
                                s => s.name === type,
                              );
                              const serviceData =
                                sortedServices[serviceIndex] || {};
                              const openingTime =
                                serviceData.opening_time || '';
                              const closingTime =
                                serviceData.closing_time || '';

                              const minOpeningTime =
                                getPreviousClosingTime(type);

                              return (
                                <div
                                  key={`${editData?.id}-${type}`}
                                  className="d-flex align-items-center mt-2">
                                  <input
                                    type="checkbox"
                                    className="form-check-input me-2 p-2"
                                    id={`service_type_${type}`}
                                    checked={isChecked}
                                    onChange={async e => {
                                      let updatedServices = [...sortedServices];

                                      if (e.target.checked) {
                                        updatedServices.push({
                                          name: type,
                                          opening_time: '',
                                          closing_time: '',
                                        });
                                        if (type === 'brunch') {
                                          updatedServices =
                                            updatedServices.filter(
                                              s => s.name === 'brunch',
                                            );
                                        } else if (
                                          type === 'lunch' &&
                                          updatedServices.some(
                                            s => s.name === 'brunch',
                                          )
                                        ) {
                                          updatedServices =
                                            updatedServices.filter(
                                              s => s.name !== 'dinner',
                                            );
                                        }
                                      } else {
                                        updatedServices =
                                          updatedServices.filter(
                                            s => s.name !== type,
                                          );
                                      }

                                      await formikEdit.setFieldValue(
                                        `service_type`,
                                        updatedServices,
                                      );
                                    }}
                                  />
                                  <label
                                    htmlFor={`service_type_${type}`}
                                    className="me-3">
                                    {type.charAt(0).toUpperCase() +
                                      type.slice(1)}
                                  </label>

                                  <div className="p-1">
                                    <label>
                                      {index === 0 && 'Opening Time'}
                                    </label>
                                    <Flatpickr
                                      options={{
                                        enableTime: true,
                                        noCalendar: true,
                                        dateFormat: 'H:i',
                                        minTime: minOpeningTime || '00:00',
                                        maxTime: '23:59',
                                      }}
                                      value={openingTime}
                                      onChange={([date]) => {
                                        let updatedServices = [
                                          ...sortedServices,
                                        ];
                                        if (serviceIndex !== -1) {
                                          // updatedServices[serviceIndex] = {
                                          //   ...updatedServices[serviceIndex],
                                          //   opening_time: date
                                          //     ? date.toTimeString().slice(0, 5)
                                          //     : '',
                                          // };
                                          updatedServices[serviceIndex] = {
                                            ...updatedServices[serviceIndex],
                                            opening_time: date
                                              ? date.toTimeString().slice(0, 5)
                                              : '',
                                            closing_time:
                                              closingTime &&
                                              date
                                                ?.toTimeString()
                                                .slice(0, 5) >= closingTime
                                                ? '' // Reset closing time if it's the same or before opening time
                                                : closingTime,
                                          };
                                          updatedServices[
                                            serviceIndex
                                          ].closing_time = '';
                                        }

                                        if (type === 'brunch') {
                                          updatedServices =
                                            updatedServices.filter(
                                              s => s.name === 'brunch',
                                            );
                                        } else if (type === 'lunch') {
                                          updatedServices =
                                            updatedServices.filter(
                                              s => s.name !== 'dinner',
                                            );
                                        }

                                        void formikEdit.setFieldValue(
                                          `service_type`,
                                          updatedServices,
                                        );
                                      }}
                                      disabled={!isChecked}
                                      className="me-2 form-control"
                                    />
                                  </div>

                                  <div>
                                    <label>
                                      {index === 0 && 'Closing Time'}
                                    </label>
                                    <Flatpickr
                                      options={{
                                        enableTime: true,
                                        noCalendar: true,
                                        dateFormat: 'H:i',
                                        // minTime: openingTime || '00:00',
                                        minTime: openingTime
                                          ? `${
                                              openingTime.split(':')[0]
                                            }:${String(
                                              parseInt(
                                                openingTime.split(':')[1],
                                              ) + 30,
                                            ).padStart(2, '0')}`
                                          : '00:01',
                                      }}
                                      value={closingTime}
                                      onChange={([date]) => {
                                        let updatedServices = [
                                          ...sortedServices,
                                        ];
                                        if (serviceIndex !== -1) {
                                          // updatedServices[serviceIndex] = {
                                          //   ...updatedServices[serviceIndex],
                                          //   closing_time: date
                                          //     ? date.toTimeString().slice(0, 5)
                                          //     : '',
                                          // };
                                          const newClosingTime = date
                                            ? date.toTimeString().slice(0, 5)
                                            : '';

                                          if (
                                            openingTime &&
                                            newClosingTime <= openingTime
                                          ) {
                                            alert(
                                              'Closing time must be at least 30 minute after opening time!',
                                            );
                                            return;
                                          }

                                          updatedServices[serviceIndex] = {
                                            ...updatedServices[serviceIndex],
                                            closing_time: newClosingTime,
                                          };
                                          if (type === 'brunch') {
                                            updatedServices =
                                              updatedServices.filter(
                                                s => s.name === 'brunch',
                                              );
                                          } else if (type === 'lunch') {
                                            updatedServices =
                                              updatedServices.filter(
                                                s => s.name !== 'dinner',
                                              );
                                          }
                                        }

                                        void formikEdit.setFieldValue(
                                          `service_type`,
                                          updatedServices,
                                        );
                                      }}
                                      disabled={!isChecked || !openingTime}
                                      className="form-control"
                                    />
                                  </div>
                                </div>
                              );
                            });
                          })()}

                          {formikEdit.touched?.service_type &&
                            formikEdit.errors?.service_type &&
                            (Array.isArray(
                              formikEdit.errors?.service_type as string,
                            ) ? (
                              <p> </p>
                            ) : (
                              <p className="text-danger">
                                {formikEdit.errors?.service_type as string}
                              </p>
                            ))}

                          {formikEdit.touched?.service_type &&
                            formikEdit.errors &&
                            typeof formikEdit.errors === 'object' &&
                            !Array.isArray(formikEdit.errors) &&
                            formikEdit.errors.service_type &&
                            Array.isArray(formikEdit.errors?.service_type) &&
                            formikEdit.errors.service_type.map((error, i) =>
                              error && typeof error === 'object' ? (
                                Object.entries(error).map(([key, message]) => (
                                  <p
                                    key={`${i}-${key}`}
                                    className="text-danger">
                                    {message as string}
                                  </p>
                                ))
                              ) : (
                                <p key={`${i}`} className="text-danger">
                                  {error}
                                </p>
                              ),
                            )}
                        </div>
                      </td>

                      <td>
                        <div className="club-select">
                          <Form.Control
                            type="number"
                            placeholder="Enter Min Party Size"
                            name="min_party_size"
                            id={`min_party_size${editData?.id}`}
                            value={formikEdit?.values.min_party_size}
                            onChange={formikEdit?.handleChange}
                            onBlur={formikEdit?.handleBlur}
                            isInvalid={
                              !!(
                                formikEdit?.touched.min_party_size &&
                                formikEdit?.errors.min_party_size
                              )
                            }
                            onWheel={e => {
                              e.currentTarget.blur();
                            }} // Prevent mouse wheel input
                          />
                          {formikEdit?.touched.min_party_size &&
                            formikEdit?.errors.min_party_size && (
                              <p className="text-danger">
                                {formikEdit?.errors.min_party_size as string}
                              </p>
                            )}
                        </div>
                      </td>
                      <td>
                        <div className="club-select">
                          <Form.Control
                            type="number"
                            placeholder="Enter Max Party Size"
                            name="max_party_size"
                            id={`max_party_size${editData?.id}`}
                            value={formikEdit?.values.max_party_size}
                            onChange={formikEdit?.handleChange}
                            onBlur={formikEdit?.handleBlur}
                            isInvalid={
                              !!(
                                formikEdit?.touched.max_party_size &&
                                formikEdit?.errors.max_party_size
                              )
                            }
                            onWheel={e => {
                              e.currentTarget.blur();
                            }} // Prevent mouse wheel input
                          />
                          {formikEdit?.touched.max_party_size &&
                            formikEdit?.errors.max_party_size && (
                              <p className="text-danger">
                                {formikEdit?.errors.max_party_size as string}
                              </p>
                            )}
                        </div>
                      </td>

                      <td>
                        <div className="club-select">
                          <Form.Control
                            type="number"
                            placeholder="Enter Price range/person"
                            name="price_range"
                            id={`price_range${editData?.id}`}
                            value={formikEdit?.values.price_range}
                            onChange={formikEdit?.handleChange}
                            onBlur={formikEdit?.handleBlur}
                            isInvalid={
                              !!(
                                formikEdit?.touched.price_range &&
                                formikEdit?.errors.price_range
                              )
                            }
                            onWheel={e => {
                              e.currentTarget.blur();
                            }} // Prevent mouse wheel input
                          />
                          {formikEdit?.touched.price_range &&
                            formikEdit?.errors.price_range && (
                              <p className="text-danger">
                                {formikEdit?.errors.price_range as string}
                              </p>
                            )}
                        </div>
                      </td>

                      <td>
                        <div className="club-select">
                          <Form.Control
                            type="number"
                            placeholder="Enter weekday discount"
                            name="weekday_discount"
                            id={`weekday_discount${editData?.id}`}
                            value={formikEdit?.values.weekday_discount}
                            onChange={formikEdit?.handleChange}
                            onBlur={formikEdit?.handleBlur}
                            isInvalid={
                              !!(
                                formikEdit?.touched.weekday_discount &&
                                formikEdit?.errors.weekday_discount
                              )
                            }
                            onWheel={e => {
                              e.currentTarget.blur();
                            }} // Prevent mouse wheel input
                          />
                          {formikEdit?.touched.weekday_discount &&
                            formikEdit?.errors.weekday_discount && (
                              <p className="text-danger">
                                {formikEdit?.errors.weekday_discount as string}
                              </p>
                            )}
                        </div>
                      </td>

                      <td>
                        <div className="club-select">
                          <Form.Control
                            type="number"
                            placeholder="Enter Weekend Discount"
                            name="weekend_discount"
                            id={`weekend_discount${editData?.id}`}
                            value={formikEdit?.values.weekend_discount}
                            onChange={formikEdit?.handleChange}
                            onBlur={formikEdit?.handleBlur}
                            isInvalid={
                              !!(
                                formikEdit?.touched.weekend_discount &&
                                formikEdit?.errors.weekend_discount
                              )
                            }
                            onWheel={e => {
                              e.currentTarget.blur();
                            }} // Prevent mouse wheel input
                          />
                          {formikEdit?.touched.weekend_discount &&
                            formikEdit?.errors.weekend_discount && (
                              <p className="text-danger">
                                {formikEdit?.errors.weekend_discount as string}
                              </p>
                            )}
                        </div>
                      </td>

                      <td>
                        <div className="club-select">
                          <Form.Control
                            as="textarea"
                            name="description"
                            rows={2}
                            id={`description${editData?.id}`}
                            value={formikEdit?.values.description}
                            onChange={formikEdit?.handleChange}
                            onBlur={formikEdit?.handleBlur}
                            isInvalid={
                              !!(
                                formikEdit?.touched.description &&
                                formikEdit?.errors.description
                              )
                            }
                          />
                          {formikEdit?.touched.description &&
                            formikEdit?.errors.description && (
                              <p className="text-danger">
                                {formikEdit?.errors.description as string}
                              </p>
                            )}
                        </div>
                      </td>

                      <td>
                        <div className="club-select">
                          <div className=" mb-1 d-flex">
                            <Form.Select
                              className="form-select edit"
                              name="table_booking_recipient_country_id"
                              id="table_booking_recipient_country_id"
                              value={
                                formikEdit?.values
                                  .table_booking_recipient_country_id || ''
                              }
                              onChange={e => {
                                const selectedId = e.target.value;
                                const selectedOption =
                                  e.target.options[e.target.selectedIndex];

                                void formikEdit.setFieldValue(
                                  'table_booking_recipient_country_id',
                                  Number(selectedId),
                                );
                                void formikEdit.setFieldValue(
                                  'country_code',
                                  selectedOption.getAttribute(
                                    'data-country-code',
                                  ),
                                );

                                void formikEdit.setFieldValue(
                                  'selected_country_code',
                                  selectedOption.getAttribute(
                                    'data-country-code',
                                  ),
                                );
                              }}>
                              <option value="">Select Country</option>
                              {countryCode?.map((data: any, i: number) => (
                                <option
                                  key={i}
                                  value={data.id}
                                  data-country-code={data.country_code}>
                                  {data.short_code} (+{data.country_code})
                                </option>
                              ))}
                            </Form.Select>

                            <Form.Control
                              type="text"
                              name="table_booking_recipient"
                              id={`table_booking_recipient${editData?.id}`}
                              value={formikEdit?.values.table_booking_recipient}
                              onChange={formikEdit?.handleChange}
                              onBlur={formikEdit?.handleBlur}
                              isInvalid={
                                !!(
                                  formikEdit?.touched.table_booking_recipient &&
                                  formikEdit?.errors.table_booking_recipient
                                )
                              }
                            />
                          </div>
                          {formikEdit?.touched.table_booking_recipient &&
                            formikEdit?.errors.table_booking_recipient && (
                              <p className="text-danger">
                                {
                                  formikEdit?.errors
                                    .table_booking_recipient as string
                                }
                              </p>
                            )}
                        </div>
                      </td>

                      <td>
                        <div className="mb-3 club-select">
                          <div className="d-flex"></div>
                          <Form.Select
                            className="form-select"
                            id={`status-Field${editData?.id}`}
                            name="status"
                            value={formikEdit?.values.status}
                            onChange={formikEdit.handleChange}
                            onBlur={formikEdit.handleBlur}>
                            <option value="" disabled>
                              --Select Status--{' '}
                            </option>
                            {statusType?.map((data: CategoryStatusList, i) => (
                              <option key={i} value={data.id}>
                                {data.name}
                              </option>
                            ))}
                          </Form.Select>
                          {formikEdit?.touched.status &&
                            formikEdit?.errors.status && (
                              <p className="text-danger">
                                {formikEdit?.errors.status as string}
                              </p>
                            )}
                        </div>
                      </td>
                    </tr>
                  </>
                ) : (
                  <>
                    {formik.values.clubs.map((club: any, index) => (
                      // // Check if the row is submitted

                      <tr key={club?.id}>
                        <td>
                          <div className="mb-3 club-select">
                            <Form.Select
                              className="form-select"
                              name={`clubs[${index}].venue_id`}
                              id={`venue_id${index}`}
                              value={club.venue_id}
                              onChange={async e => {
                                // eslint-disable-next-line @typescript-eslint/no-confusing-void-expression
                                const selectedVenue: any = categoryList.find(
                                  // eslint-disable-next-line array-callback-return
                                  (venue: CategoryDetailsTypes) =>
                                    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
                                    String(venue.id) == e.target.value,
                                );

                                await formik.setFieldValue(
                                  `clubs[${index}].address`,
                                  selectedVenue?.address || '',
                                );
                                await handleImage(
                                  selectedVenue?.image,
                                  index,
                                  true,
                                );

                                setImageDisplay((prevState: any) => ({
                                  ...prevState,
                                  [index]: selectedVenue?.image,
                                }));
                                setTimeout(() => {
                                  void formik.setFieldValue(
                                    `clubs[${index}].venue_id`,
                                    selectedVenue?.id || '',
                                  );
                                }, 0);

                                // eslint-disable-next-line @typescript-eslint/no-unused-expressions
                                formik?.handleChange(e);
                              }}
                              // onChange={formik?.handleChange}
                              onBlur={formik?.handleBlur}>
                              <option value="" disabled>
                                --Select Venue--
                              </option>
                              {categoryList?.map(
                                (data: CategoryDetailsTypes, i) => {
                                  // Ensure the category name does not match the editEvent's name
                                  if (editData?.event_name !== data.name) {
                                    const categoryName = renderCategoryOptions(
                                      data,
                                      categoryList,
                                      [],
                                      editData?.event_name,
                                    );

                                    return (
                                      <option value={data.id} key={i}>
                                        {categoryName}
                                      </option>
                                    );
                                  }
                                  return null; // Avoid rendering anything if the condition is not met
                                },
                              )}
                            </Form.Select>
                            {formik.touched.clubs?.[index]?.venue_id &&
                              formik.errors.clubs?.[index] && (
                                <p className="text-danger">
                                  {
                                    (formik.errors.clubs[index] as any)
                                      ?.venue_id
                                  }
                                </p>
                              )}
                          </div>
                        </td>

                        <td>
                          <div className="club-select">
                            <div className="avatar-upload">
                              <div className="avatar-edit">
                                <input
                                  type="file"
                                  // id="imageUpload"
                                  id={`imageUpload${index}`}
                                  name={`clubs[${index}].image`}
                                  onChange={async e => {
                                    await handleImage(e, index);
                                  }}
                                  accept="image/jpeg, image/png, image/jpg, image/gif, image/svg+xml, image/webp"
                                />
                                <label
                                  htmlFor={`imageUpload${index}`}
                                  className="image-upload-cam d-flex justify-content-center align-items-center">
                                  <i className="ri-image-fill"></i>
                                </label>
                              </div>
                              <div className="avatar-preview">
                                <img
                                  className="preview-select-img img-responsive img-circle"
                                  id="imagePreview"
                                  alt="User profile picture"
                                  src={
                                    imageDisplay?.[index] ??
                                    categoryImagePlaceholder
                                  }
                                  style={{height: '110px'}}
                                />
                              </div>
                            </div>
                            {formik.touched.clubs?.[index]?.image &&
                              formik.errors.clubs?.[index] && (
                                <p className="text-danger">
                                  {(formik.errors.clubs[index] as any)?.image}
                                </p>
                              )}
                          </div>
                        </td>

                        <td>
                          <div className="club-select">
                            <Form.Control
                              type="text"
                              name={`clubs[${index}].name`}
                              id={`name${index}`}
                              value={club.name}
                              onChange={formik?.handleChange}
                              onBlur={async e => {
                                const isAvailable =
                                  await checkRestaurantNameAvailability(
                                    club?.name,
                                    index,
                                  );
                                formik?.handleBlur(e);
                              }}
                              // onBlur={formik?.handleBlur}
                              isInvalid={
                                !!(
                                  formik.touched.clubs?.[index]?.name &&
                                  (formik.errors.clubs?.[index] as any)?.name
                                )
                              }
                            />

                            {formik.touched.clubs?.[index]?.name &&
                              formik.errors.clubs?.[index] && (
                                <p className="text-danger">
                                  {(formik.errors.clubs[index] as any)?.name}
                                </p>
                              )}
                          </div>
                        </td>

                        <td>
                          <>
                            {/* <FileUploaderClub
                              //  onFilesAdded={handleFilesAdded}
                              onFilesAdded={async files => {
                                await handleFilesAdded(files, index);
                              }} // Pass rowIndex
                              accept={{
                                'image/*': ['.png', '.jpeg', '.jpg', '.gif'],
                                'video/*': ['.mp4', '.mov', '.avi'],
                              }}
                              multiple={true}
                              images={uploadedFiles[index] || []} // Display only row-specific images
                              rowIndex={index}
                            /> */}

                            <FileUploader
                              onFilesAdded={async files => {
                                await handleFilesAdded(files, index);
                              }} // Pass rowIndex
                              accept={{
                                'image/*': ['.png', '.jpeg', '.jpg', '.gif'],
                                'video/*': ['.mp4', '.mov', '.avi'],
                              }}
                              multiple={true}
                              images={uploadedFiles[index] || []}
                            />
                            {formik.touched.clubs?.[index]?.files &&
                              formik.errors.clubs?.[index] && (
                                <p className="text-danger">
                                  {(formik.errors.clubs[index] as any)?.files}
                                </p>
                              )}
                          </>
                        </td>

                        <td>
                          <div className="mb-3 club-select">
                            <div className="d-flex"></div>
                            <Form.Select
                              className="form-select"
                              id={`type-Field${index}`}
                              name={`clubs[${index}].type`}
                              value={club.type}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}>
                              <option value="" disabled>
                                --Select Type--{' '}
                              </option>
                              {clubType?.map((data: CategoryStatusList, i) => (
                                <option key={i} value={data.id}>
                                  {data.name}
                                </option>
                              ))}
                            </Form.Select>
                            {formik.touched.clubs?.[index]?.type &&
                              formik.errors.clubs?.[index] && (
                                <p className="text-danger">
                                  {(formik.errors.clubs[index] as any)?.type}
                                </p>
                              )}
                          </div>
                        </td>

                        <td>
                          <div className="club-select">
                            <Form.Control
                              as="textarea"
                              rows={2}
                              name={`clubs[${index}].address`}
                              id={`address${index}`}
                              value={club.address}
                              onChange={formik?.handleChange}
                              onBlur={formik?.handleBlur}
                              isInvalid={
                                !!(
                                  formik.touched.clubs?.[index]?.address &&
                                  (formik.errors.clubs?.[index] as any)?.address
                                )
                              }
                            />
                            {formik.touched.clubs?.[index]?.address &&
                              formik.errors.clubs?.[index] && (
                                <p className="text-danger">
                                  {(formik.errors.clubs[index] as any)?.address}
                                </p>
                              )}
                          </div>
                        </td>

                        <td>
                          <div className="mb-3 club-select">
                            <Form.Select
                              className="form-select"
                              name={`clubs[${index}].commision_status`}
                              id={`commision_status${index}`}
                              value={club.commision_status}
                              onChange={formik?.handleChange}
                              onBlur={formik?.handleBlur}>
                              <option value="" disabled>
                                Select
                              </option>
                              {status?.map((data: CategoryStatusList, i) => (
                                <option key={i} value={data.id}>
                                  {data.name}
                                </option>
                              ))}
                            </Form.Select>
                            {formik.touched.clubs?.[index]?.commision_status &&
                              formik.errors.clubs?.[index] && (
                                <p className="text-danger">
                                  {
                                    (formik.errors.clubs[index] as any)
                                      ?.commision_status
                                  }
                                </p>
                              )}
                          </div>
                        </td>
                        <td>
                          <div className="mb-3 club-select">
                            <Form.Control
                              type="text"
                              name={`clubs[${index}].cuisine`}
                              id={`cuisine${index}`}
                              value={club.cuisine}
                              onChange={formik?.handleChange}
                              onBlur={formik?.handleBlur}
                              isInvalid={
                                !!(
                                  formik.touched.clubs?.[index]?.cuisine &&
                                  (formik.errors.clubs?.[index] as any)?.cuisine
                                )
                              }
                            />
                            {formik.touched.clubs?.[index]?.cuisine &&
                              formik.errors.clubs?.[index] && (
                                <p className="text-danger">
                                  {(formik.errors.clubs[index] as any)?.cuisine}
                                </p>
                              )}
                          </div>
                        </td>
                        <td>
                          <div className="mb-3 club-select">
                            <Form.Control
                              type="text"
                              name={`clubs[${index}].tag`}
                              id={`tag${index}`}
                              value={club.tag}
                              onChange={formik?.handleChange}
                              onBlur={formik?.handleBlur}
                              isInvalid={
                                !!(
                                  formik.touched.clubs?.[index]?.tag &&
                                  (formik.errors.clubs?.[index] as any)?.tag
                                )
                              }
                            />
                            {formik.touched.clubs?.[index]?.tag &&
                              formik.errors.clubs?.[index] && (
                                <p className="text-danger">
                                  {(formik.errors.clubs[index] as any)?.tag}
                                </p>
                              )}
                          </div>
                        </td>
                        <td>
                          <div className="club-select">
                            <Form.Select
                              className="form-select "
                              name={`clubs[${index}].indoors`}
                              id={`indoors${index}`}
                              value={club.indoors}
                              onChange={formik?.handleChange}
                              onBlur={formik?.handleBlur}>
                              <option value="" disabled>
                                --Select Indoors--
                              </option>
                              {status?.map((data: CategoryStatusList, i) => (
                                <option key={i} value={data.id}>
                                  {data.name}
                                </option>
                              ))}
                            </Form.Select>
                            {formik.touched.clubs?.[index]?.indoors &&
                              formik.errors.clubs?.[index] && (
                                <p className="text-danger">
                                  {(formik.errors.clubs[index] as any)?.indoors}
                                </p>
                              )}
                          </div>
                        </td>
                        <td>
                          <div className="club-select">
                            <Form.Select
                              className="form-select "
                              name={`clubs[${index}].outdoors`}
                              id={`outdoors${index}`}
                              value={club.outdoors}
                              onChange={formik?.handleChange}
                              onBlur={formik?.handleBlur}>
                              <option value="" disabled>
                                --Select Outdoors--
                              </option>
                              {status?.map((data: CategoryStatusList, i) => (
                                <option key={i} value={data.id}>
                                  {data.name}
                                </option>
                              ))}
                            </Form.Select>
                            {formik.touched.clubs?.[index]?.outdoors &&
                              formik.errors.clubs?.[index] && (
                                <p className="text-danger">
                                  {
                                    (formik.errors.clubs[index] as any)
                                      ?.outdoors
                                  }
                                </p>
                              )}
                          </div>
                        </td>
                        <td>
                          <div className="club-select">
                            <Form.Select
                              className="form-select "
                              name={`clubs[${index}].bar`}
                              id={`bar${index}`}
                              value={club.bar}
                              onChange={formik?.handleChange}
                              onBlur={formik?.handleBlur}>
                              <option value="" disabled>
                                --Select Bar--
                              </option>
                              {status?.map((data: CategoryStatusList, i) => (
                                <option key={i} value={data.id}>
                                  {data.name}
                                </option>
                              ))}
                            </Form.Select>
                            {formik.touched.clubs?.[index]?.bar &&
                              formik.errors.clubs?.[index] && (
                                <p className="text-danger">
                                  {(formik.errors.clubs[index] as any)?.bar}
                                </p>
                              )}
                          </div>
                        </td>
                        <td>
                          <div className="club-select">
                            <Form.Select
                              className="form-select "
                              name={`clubs[${index}].special_events`}
                              id={`special_events${index}`}
                              value={club.special_events}
                              onChange={formik?.handleChange}
                              onBlur={formik?.handleBlur}>
                              <option value="" disabled>
                                --Select Special Events--
                              </option>
                              {status?.map((data: CategoryStatusList, i) => (
                                <option key={i} value={data.id}>
                                  {data.name}
                                </option>
                              ))}
                            </Form.Select>
                            {formik.touched.clubs?.[index]?.special_events &&
                              formik.errors.clubs?.[index] && (
                                <p className="text-danger">
                                  {
                                    (formik.errors.clubs[index] as any)
                                      ?.special_events
                                  }
                                </p>
                              )}
                          </div>
                        </td>

                        <td>
                          <div className="club-select">
                            {/* Service Type Selection (Brunch, Lunch, Dinner) */}

                            {(() => {
                              const existingServiceTypes =
                                formik.values.clubs?.[index]?.service_type ||
                                [];
                              const order = ['brunch', 'lunch', 'dinner'];

                              const sortedServices = [
                                ...existingServiceTypes,
                              ].sort(
                                (a, b) =>
                                  order.indexOf(a.name) - order.indexOf(b.name),
                              );

                              return order.map((type, typeIndex) => {
                                const isChecked = sortedServices.some(
                                  service => service.name === type,
                                );
                                const currentService = sortedServices.find(
                                  s => s.name === type,
                                );
                                const openingTime =
                                  currentService?.opening_time || '';
                                const closingTime =
                                  currentService?.closing_time || '';

                                const previousMealClosingTime =
                                  typeIndex > 0
                                    ? sortedServices.find(
                                        s => s.name === order[typeIndex - 1],
                                      )?.closing_time || ''
                                    : '';

                                const nextMealOpeningTime =
                                  typeIndex < order.length - 1
                                    ? sortedServices.find(
                                        s => s.name === order[typeIndex + 1],
                                      )?.opening_time || ''
                                    : '';

                                return (
                                  <div
                                    key={`${index}-${type}`}
                                    className="d-flex align-items-center mt-2">
                                    {/* Checkbox */}
                                    <input
                                      type="checkbox"
                                      className="form-check-input me-2 p-2"
                                      id={`clubs_${index}_service_type_${type}`}
                                      checked={isChecked}
                                      onChange={e => {
                                        let updatedServices = [
                                          ...sortedServices,
                                        ];

                                        if (e.target.checked) {
                                          // Add the selected meal
                                          updatedServices.push({
                                            name: type,
                                            opening_time:
                                              existingServiceTypes.find(
                                                (s: {name: string}) =>
                                                  s.name === type,
                                              )?.opening_time || '',
                                            closing_time:
                                              existingServiceTypes.find(
                                                (s: {name: string}) =>
                                                  s.name === type,
                                              )?.closing_time || '',
                                          });

                                          // Reset later meal times if a previous meal is added
                                          if (type === 'brunch') {
                                            updatedServices =
                                              updatedServices.map(service =>
                                                ['lunch', 'dinner'].includes(
                                                  service.name,
                                                )
                                                  ? {
                                                      ...service,
                                                      opening_time: '',
                                                      closing_time: '',
                                                    }
                                                  : service,
                                              );
                                          }

                                          if (type === 'lunch') {
                                            updatedServices =
                                              updatedServices.map(service =>
                                                service.name === 'dinner'
                                                  ? {
                                                      ...service,
                                                      opening_time: '',
                                                      closing_time: '',
                                                    }
                                                  : service,
                                              );
                                          }
                                        } else {
                                          // If unchecked, remove it
                                          updatedServices =
                                            updatedServices.filter(
                                              service => service.name !== type,
                                            );
                                        }

                                        // Keep the correct order (Brunch → Lunch → Dinner)
                                        updatedServices = updatedServices.sort(
                                          (a, b) =>
                                            order.indexOf(a.name) -
                                            order.indexOf(b.name),
                                        );

                                        void formik.setFieldValue(
                                          `clubs[${index}].service_type`,
                                          updatedServices,
                                        );
                                      }}
                                    />
                                    <label
                                      htmlFor={`clubs_${index}_service_type_${type}`}
                                      className="me-3">
                                      {type.charAt(0).toUpperCase() +
                                        type.slice(1)}
                                    </label>

                                    {/* Opening Time */}
                                    <div className="p-1">
                                      <label>
                                        {' '}
                                        {typeIndex == 0 && 'Opening Time'}
                                      </label>
                                      <Flatpickr
                                        options={{
                                          enableTime: true,
                                          noCalendar: true,
                                          dateFormat: 'H:i',
                                          minTime:
                                            previousMealClosingTime || '00:00',
                                          maxTime:
                                            nextMealOpeningTime || '23:59',
                                          onClose: () => {
                                            (
                                              document.activeElement as HTMLElement
                                            )?.blur();
                                          },
                                        }}
                                        value={openingTime}
                                        onChange={([date]) => {
                                          const newTime = date
                                            ? date.toTimeString().slice(0, 5)
                                            : '';

                                          void formik.setFieldValue(
                                            `clubs[${index}].service_type[${sortedServices.findIndex(
                                              s => s.name === type,
                                            )}].opening_time`,
                                            newTime,
                                          );

                                          // Reset closing time if it is before the new opening time
                                          if (
                                            closingTime &&
                                            newTime > closingTime
                                          ) {
                                            void formik.setFieldValue(
                                              `clubs[${index}].service_type[${sortedServices.findIndex(
                                                s => s.name === type,
                                              )}].closing_time`,
                                              '',
                                            );
                                          }

                                          // Reset later meal times when modifying an earlier meal time
                                          if (type === 'brunch') {
                                            ['lunch', 'dinner'].forEach(
                                              meal => {
                                                const mealIndex =
                                                  sortedServices.findIndex(
                                                    s => s.name === meal,
                                                  );
                                                if (mealIndex !== -1) {
                                                  void formik.setFieldValue(
                                                    `clubs[${index}].service_type[${mealIndex}].opening_time`,
                                                    '',
                                                  );
                                                  void formik.setFieldValue(
                                                    `clubs[${index}].service_type[${mealIndex}].closing_time`,
                                                    '',
                                                  );
                                                }
                                              },
                                            );
                                          } else if (type === 'lunch') {
                                            const dinnerIndex =
                                              sortedServices.findIndex(
                                                s => s.name === 'dinner',
                                              );
                                            if (dinnerIndex !== -1) {
                                              void formik.setFieldValue(
                                                `clubs[${index}].service_type[${dinnerIndex}].opening_time`,
                                                '',
                                              );
                                              void formik.setFieldValue(
                                                `clubs[${index}].service_type[${dinnerIndex}].closing_time`,
                                                '',
                                              );
                                            }
                                          }
                                        }}
                                        // onChange={([date]) => {
                                        //   const newTime = date
                                        //     ? date.toTimeString().slice(0, 5)
                                        //     : '';
                                        //   void formik.setFieldValue(
                                        //     `clubs[${index}].service_type[${sortedServices.findIndex(
                                        //       s => s.name === type,
                                        //     )}].opening_time`,
                                        //     newTime,
                                        //   );

                                        //   // Reset closing time if it is before the new opening time
                                        //   if (
                                        //     closingTime &&
                                        //     newTime > closingTime
                                        //   ) {
                                        //     void formik.setFieldValue(
                                        //       `clubs[${index}].service_type[${sortedServices.findIndex(
                                        //         s => s.name === type,
                                        //       )}].closing_time`,
                                        //       '',
                                        //     );
                                        //   }
                                        // }}
                                        className="form-control me-2"
                                        disabled={!isChecked}
                                      />
                                    </div>

                                    {/* Closing Time */}
                                    <div className="">
                                      <label>
                                        {' '}
                                        {typeIndex == 0 && 'Closing Time'}
                                      </label>
                                      <Flatpickr
                                        options={{
                                          enableTime: true,
                                          noCalendar: true,
                                          dateFormat: 'H:i',
                                          // minTime: openingTime || '00:00',
                                          minTime: openingTime
                                            ? `${
                                                openingTime.split(':')[0]
                                              }:${String(
                                                parseInt(
                                                  openingTime.split(':')[1],
                                                ) + 30,
                                              ).padStart(2, '0')}`
                                            : '00:01', // Ensure closing time is at least 1 minute after opening time
                                          maxTime:
                                            nextMealOpeningTime || '23:59',
                                        }}
                                        value={closingTime}
                                        onChange={([date]) => {
                                          const newTime = date
                                            ? date.toTimeString().slice(0, 5)
                                            : '';
                                          void formik.setFieldValue(
                                            `clubs[${index}].service_type[${sortedServices.findIndex(
                                              s => s.name === type,
                                            )}].closing_time`,
                                            newTime,
                                          );
                                        }}
                                        className="form-control"
                                        disabled={!isChecked || !openingTime}
                                      />
                                    </div>
                                  </div>
                                );
                              });
                            })()}

                            {formik.touched.clubs?.[index]?.service_type &&
                              formik.errors.clubs?.[index] &&
                              (Array.isArray(
                                (formik.errors.clubs?.[index] as any)
                                  ?.service_type,
                              ) ? (
                                <p> </p>
                              ) : (
                                <p className="text-danger">
                                  {
                                    (formik.errors.clubs?.[index] as any)
                                      ?.service_type
                                  }
                                </p>
                              ))}

                            {formik.touched.clubs?.[index]?.service_type &&
                              formik.errors.clubs?.[index] &&
                              typeof formik.errors.clubs[index] === 'object' &&
                              !Array.isArray(formik.errors.clubs[index]) &&
                              (
                                formik.errors.clubs[
                                  index
                                ] as FormikErrors<ClubRow>
                              ).service_type &&
                              Array.isArray(
                                (
                                  formik.errors.clubs[
                                    index
                                  ] as FormikErrors<ClubRow>
                                ).service_type,
                              ) &&
                              (
                                (
                                  formik.errors.clubs[
                                    index
                                  ] as FormikErrors<ClubRow>
                                ).service_type as Array<FormikErrors<any>>
                              ).map((error, i) =>
                                error && typeof error === 'object' ? (
                                  Object.entries(error).map(
                                    ([key, message]) => (
                                      <p
                                        key={`${index}-${i}-${key}`}
                                        className="text-danger">
                                        {message as string}
                                      </p>
                                    ),
                                  )
                                ) : (
                                  <p
                                    key={`${index}-${i}`}
                                    className="text-danger">
                                    {error as string}
                                  </p>
                                ),
                              )}
                          </div>
                        </td>

                        <td>
                          <div className="club-select">
                            <Form.Control
                              type="number"
                              placeholder="Enter Min Party Size"
                              name={`clubs[${index}].min_party_size`}
                              id={`min_party_size${index}`}
                              value={club.min_party_size}
                              onChange={formik?.handleChange}
                              onBlur={formik?.handleBlur}
                              isInvalid={
                                !!(
                                  formik.touched.clubs?.[index]
                                    ?.min_party_size &&
                                  (formik.errors.clubs?.[index] as any)
                                    ?.min_party_size
                                )
                              }
                              onWheel={e => {
                                e.currentTarget.blur();
                              }} // Prevent mouse wheel input
                            />
                            {formik.touched.clubs?.[index]?.min_party_size &&
                              formik.errors.clubs?.[index] && (
                                <p className="text-danger">
                                  {
                                    (formik.errors.clubs[index] as any)
                                      ?.min_party_size
                                  }
                                </p>
                              )}
                          </div>
                        </td>
                        <td>
                          <div className="club-select">
                            <Form.Control
                              type="number"
                              placeholder="Enter Max Party Size"
                              name={`clubs[${index}].max_party_size`}
                              id={`max_party_size${index}`}
                              value={club.max_party_size}
                              onChange={formik?.handleChange}
                              onBlur={formik?.handleBlur}
                              isInvalid={
                                !!(
                                  formik.touched.clubs?.[index]
                                    ?.max_party_size &&
                                  (formik.errors.clubs?.[index] as any)
                                    ?.max_party_size
                                )
                              }
                              onWheel={e => {
                                e.currentTarget.blur();
                              }} // Prevent mouse wheel input
                              min={club?.min_party_size}
                            />
                            {formik.touched.clubs?.[index]?.max_party_size &&
                              formik.errors.clubs?.[index] && (
                                <p className="text-danger">
                                  {
                                    (formik.errors.clubs[index] as any)
                                      ?.max_party_size
                                  }
                                </p>
                              )}
                          </div>
                        </td>

                        <td>
                          <div className="club-select">
                            <Form.Control
                              type="number"
                              placeholder="Enter Price range/person"
                              name={`clubs[${index}].price_range`}
                              id={`price_range${index}`}
                              value={club.price_range}
                              onChange={formik?.handleChange}
                              onBlur={formik?.handleBlur}
                              isInvalid={
                                !!(
                                  formik.touched.clubs?.[index]?.price_range &&
                                  (formik.errors.clubs?.[index] as any)
                                    ?.price_range
                                )
                              }
                              onWheel={e => {
                                e.currentTarget.blur();
                              }} // Prevent mouse wheel input
                            />
                            {formik.touched.clubs?.[index]?.price_range &&
                              formik.errors.clubs?.[index] && (
                                <p className="text-danger">
                                  {
                                    (formik.errors.clubs[index] as any)
                                      ?.price_range
                                  }
                                </p>
                              )}
                          </div>
                        </td>

                        <td>
                          <div className="club-select">
                            <Form.Control
                              type="number"
                              placeholder="Enter weekday discount"
                              name={`clubs[${index}].weekday_discount`}
                              id={`weekday_discount${index}`}
                              value={club.weekday_discount}
                              onChange={formik?.handleChange}
                              onBlur={formik?.handleBlur}
                              isInvalid={
                                !!(
                                  formik.touched.clubs?.[index]
                                    ?.weekday_discount &&
                                  (formik.errors.clubs?.[index] as any)
                                    ?.weekday_discount
                                )
                              }
                              onWheel={e => {
                                e.currentTarget.blur();
                              }} // Prevent mouse wheel input
                            />
                            {formik.touched.clubs?.[index]?.weekday_discount &&
                              formik.errors.clubs?.[index] && (
                                <p className="text-danger">
                                  {
                                    (formik.errors.clubs[index] as any)
                                      ?.weekday_discount
                                  }
                                </p>
                              )}
                          </div>
                        </td>

                        <td>
                          <div className="club-select">
                            <Form.Control
                              type="number"
                              placeholder="Enter Weekend Discount"
                              name={`clubs[${index}].weekend_discount`}
                              id={`weekend_discount${index}`}
                              value={club.weekend_discount}
                              onChange={formik?.handleChange}
                              onBlur={formik?.handleBlur}
                              isInvalid={
                                !!(
                                  formik.touched.clubs?.[index]
                                    ?.weekend_discount &&
                                  (formik.errors.clubs?.[index] as any)
                                    ?.weekend_discount
                                )
                              }
                              onWheel={e => {
                                e.currentTarget.blur();
                              }} // Prevent mouse wheel input
                            />
                            {formik.touched.clubs?.[index]?.weekend_discount &&
                              formik.errors.clubs?.[index] && (
                                <p className="text-danger">
                                  {
                                    (formik.errors.clubs[index] as any)
                                      ?.weekend_discount
                                  }
                                </p>
                              )}
                          </div>
                        </td>

                        <td>
                          <div className="club-select">
                            <Form.Control
                              as="textarea"
                              name={`clubs[${index}].description`}
                              rows={2}
                              id={`description${index}`}
                              value={club.description}
                              onChange={formik?.handleChange}
                              onBlur={formik?.handleBlur}
                              isInvalid={
                                !!(
                                  formik.touched.clubs?.[index]?.description &&
                                  (formik.errors.clubs?.[index] as any)
                                    ?.description
                                )
                              }
                            />
                            {formik.touched.clubs?.[index]?.description &&
                              formik.errors.clubs?.[index] && (
                                <p className="text-danger">
                                  {
                                    (formik.errors.clubs[index] as any)
                                      ?.description
                                  }
                                </p>
                              )}
                          </div>
                        </td>
                        <td>
                          <div className="club-select">
                            <div className="mb-1 d-flex gap-2 align-items-center">
                              {/* Country Code Select */}
                              <Form.Select
                                className="form-select add"
                                name={`clubs[${index}].table_booking_recipient_country_id`}
                                value={
                                  formik.values.clubs?.[index]
                                    ?.table_booking_recipient_country_id ??
                                  '229'
                                }
                                onChange={e => {
                                  const selectedId = e.target.value;
                                  const selectedOption =
                                    e.target.options[e.target.selectedIndex];

                                  void formik.setFieldValue(
                                    `clubs[${index}].table_booking_recipient_country_id`,
                                    selectedId,
                                  );
                                  void formik.setFieldValue(
                                    `clubs[${index}].country_code`,
                                    selectedOption.getAttribute(
                                      'data-country-code',
                                    ),
                                  );
                                }}
                                style={{width: 'fit-content'}}>
                                <option value="">Select</option>
                                {countryCode?.map((data: any, i: number) => (
                                  <option
                                    key={i}
                                    value={String(data.id)}
                                    data-country-code={data.country_code}>
                                    {data.short_code} (+{data.country_code})
                                  </option>
                                ))}
                              </Form.Select>

                              {/* Phone Number Input */}
                              <Form.Control
                                type="number"
                                placeholder="Enter phone number"
                                name={`clubs[${index}].table_booking_recipient`}
                                id={`table_booking_recipient${index}`}
                                value={
                                  formik.values.clubs?.[index]
                                    ?.table_booking_recipient ?? ''
                                }
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                isInvalid={
                                  !!(
                                    formik.touched.clubs?.[index]
                                      ?.table_booking_recipient &&
                                    (formik.errors.clubs?.[index] as any)
                                      ?.table_booking_recipient
                                  )
                                }
                                onWheel={e => {
                                  e.currentTarget.blur();
                                }} // Prevent mouse wheel input
                              />
                            </div>

                            {/* Error message */}
                            {formik.touched.clubs?.[index]
                              ?.table_booking_recipient &&
                              formik.errors.clubs?.[index] && (
                                <p
                                  className="text-danger"
                                  style={{maxWidth: '100%'}}>
                                  {
                                    (formik.errors.clubs[index] as any)
                                      ?.table_booking_recipient
                                  }
                                </p>
                              )}
                          </div>
                        </td>
                        <td>
                          <div className="mb-3 club-select">
                            <div className="d-flex"></div>
                            <Form.Select
                              className="form-select"
                              id={`status-Field${index}`}
                              name={`clubs[${index}].status`}
                              value={club.status}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}>
                              <option value="" disabled>
                                --Select Status--
                              </option>
                              {statusType?.map(
                                (data: CategoryStatusList, i) => (
                                  <option key={i} value={data.id}>
                                    {data.name}
                                  </option>
                                ),
                              )}
                            </Form.Select>
                            {formik.touched.clubs?.[index]?.status &&
                              formik.errors.clubs?.[index] && (
                                <p className="text-danger">
                                  {(formik.errors.clubs[index] as any)?.status}
                                </p>
                              )}
                          </div>
                        </td>

                        <td className="text-center align-middle">
                          <div className="d-flex  align-items-center justify-content-center">
                            {index === formik.values.clubs.length - 1 && (
                              <Button
                                variant="success"
                                type="button"
                                className="d-flex align-items-center justify-content-center me-1"
                                style={{
                                  width: '32px',
                                  height: '32px',
                                  fontSize: '20px',
                                  padding: '0',
                                }}
                                onClick={addRow}>
                                +
                              </Button>
                            )}

                            {/* "-" Button: Shows on all rows except the first */}
                            {formik.values.clubs.length > 1 && (
                              <Button
                                variant="danger"
                                type="button"
                                className=" d-flex align-items-center justify-content-center mt-1 me-1"
                                style={{
                                  width: '32px',
                                  height: '32px',
                                  fontSize: '20px',
                                  padding: '0',
                                }}
                                onClick={async () => {
                                  await removeRow(index);
                                }}>
                                -
                              </Button>
                            )}
                          </div>
                        </td>
                      </tr>
                    ))}
                  </>
                )}
              </tbody>
            </Table>
            <div className=" m-2">
              {!editData?.id ? (
                <Button
                  variant="primary"
                  onClick={async () => await formik.submitForm()}
                  className="mt-3">
                  Add Restaurant
                </Button>
              ) : (
                <Button
                  variant="primary"
                  type="button"
                  onClick={handleEditSubmit}>
                  Edit Restaurant
                </Button>
              )}
            </div>
          </div>
        </Col>
      </Row>
      {/* </Container> */}
    </div>
  );
};

export default RestaurantForm;
